define('studio/track-list',["require", "exports", "../baseline/search", "../tracks/starred", "../tracks/track-enabled", "../tracks/track-state", "../tracks/track-store"], function (require, exports, search_1, starred, trackEnabled, trackState, trackStore) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TrackList = void 0;
    /**
     * View controller for track listing
     */
    var TrackList = /** @class */ (function () {
        function TrackList(userId, authUserId) {
            var _this = this;
            // HTML Elements
            this.element = document.getElementById("studio-track-list");
            this.listDiv = document.getElementById("studio-track-list-items");
            this.searchBox = document.getElementById("studio-track-list-search");
            this.tracks = [];
            this.authUserId = authUserId;
            // Bind to search box
            this.searchBox.onkeyup = function () {
                _this.render();
            };
            // Get tracks
            trackStore.getUserTracks(userId).then(function (tracks) {
                _this.tracks = tracks;
                // If WSBASE tracks exist, default search to "Wingsuit BASE"
                if (_this.tracks.find(function (track) { return (0, search_1.matchTrack)(track, "Wingsuit BASE"); }) !== undefined) {
                    _this.searchBox.value = "Wingsuit BASE";
                }
                _this.render();
            });
        }
        // Render list of lasers
        TrackList.prototype.render = function () {
            var _this = this;
            var searchString = this.searchBox.value;
            this.listDiv.innerText = "";
            // Add tracks
            this.tracks
                .filter(function (track) { return (0, search_1.matchTrack)(track, searchString); })
                .forEach(function (track) { return _this.addTrack(track); });
        };
        /**
         * Generate track list item html
         */
        TrackList.prototype.addTrack = function (track) {
            var trackDiv = document.createElement("div");
            trackDiv.innerHTML = "\n      <div>\n        <time>" + track.date_string + "</time>\n        <div>" + (track.location || "&nbsp;") + "</div>\n      </div>\n      <a href=\"/tracks/" + track.track_id + "\" class=\"open-link\"></a>";
            // baseline comparison track
            if (track.user_id == this.authUserId) {
                var star = document.createElement("img");
                star.src = "/assets/images/icons/star.svg";
                star.alt = star.title = "Star for baseline comparison track";
                star.classList.add("starred-track");
                starred.bind(track, star);
                trackDiv.prepend(star);
            }
            trackDiv.classList.add("studio-item");
            // Subscribe to enabled state
            trackEnabled.observe(track.track_id).subscribeNow(function (isEnabled) {
                if (isEnabled) {
                    trackDiv.classList.add("active");
                }
                else {
                    trackDiv.classList.remove("active");
                }
            });
            trackDiv.addEventListener("click", function () {
                if (trackEnabled.isEnabled(track.track_id)) {
                    trackEnabled.remove(track.track_id);
                    trackState.highlight.set(undefined);
                }
                else {
                    trackEnabled.addTrack(track.track_id);
                }
            });
            trackDiv.addEventListener("mouseover", function () {
                if (trackEnabled.isEnabled(track.track_id)) {
                    trackState.highlight.set(track.track_id);
                }
            });
            trackDiv.addEventListener("mouseout", function () { return trackState.highlight.set(undefined); });
            this.listDiv.appendChild(trackDiv);
        };
        return TrackList;
    }());
    exports.TrackList = TrackList;
});
//# sourceMappingURL=/assets/javascripts/studio/track-list.js.map;
